<template>

</template>

<script>
    export default {

        data() {
            return {};
        },
        mounted() {

        }
    }

</script>

<style rel="stylesheet/scss" lang="scss" type="text/css" scoped>
    .content {
        padding-bottom:2px;

        .invert & {
            color: theme('colors.white');
        }

        .active & {
            color: theme('colors.white');
            .invert & {
                color: theme('colors.black');
            }
        }
    }

    .right, .left {
        height: 32px;
        width: 51px;

        @screen xl {
            height: 26px;
            width: 42px;
        }

    }

    .right {

        border: 1px solid theme('colors.black');

        .invert & {
            border: 1px solid theme('colors.white');
        }
        border-bottom-right-radius: 90px;
        border-top-right-radius: 90px;
    }

    .left {
        border: 1px solid theme('colors.black');
        .invert & {
            border: 1px solid theme('colors.white');
        }
        border-bottom-left-radius: 90px;
        border-top-left-radius: 90px;
    }

    .active {
        background:theme('colors.black');
        color: theme('colors.white');
        .invert & {
            background:theme('colors.white');
            color: theme('colors.black');
        }
    }

</style>
